// @ts-strict-ignore
import React from 'react';
import ReadMore from 'react-native-read-more-text';
import { Inline } from '@styleseat/ui';
import BodyText from './BodyText';
import Button from './Button';

type SeeMoreProps = {
  children: React.ReactNode;
  numberOfLines?: number;
  centered?: boolean;
};

/**
 * A component responsible for displaying text blurbs.
 * Provide the maximum number of lines that should display (default is 3).
 * When the text exceeds the number of lines, there is an action available to expand
 * to view the rest of the text.
 */
const SeeMore: React.FCWithChildren<SeeMoreProps> = ({
  children,
  numberOfLines = 3,
  centered,
}) => (
  <ReadMore
    textStyle={{
      textAlign: centered ? 'center' : undefined,
    }}
    numberOfLines={numberOfLines}
    renderTruncatedFooter={handlePress => (
      <Inline
        flexGrow={1}
        justifyContent={centered ? 'center' : 'flex-start'}
        paddingTop={12}
      >
        <Button
          onClick={handlePress}
          appearance="text-primary"
          size="small"
          style={{
            paddingLeft: 0,
            paddingRight: 0,
            borderWidth: 0,
          }}
        >
          See more
        </Button>
      </Inline>
    )}
    renderRevealedFooter={handlePress => (
      <Inline
        flexGrow={1}
        justifyContent={centered ? 'center' : 'flex-start'}
        paddingTop={12}
      >
        <Button
          onClick={handlePress}
          appearance="text-primary"
          size="small"
          style={{
            paddingLeft: 0,
            paddingRight: 0,
            borderWidth: 0,
          }}
        >
          See less
        </Button>
      </Inline>
    )}
  >
    <BodyText weight="thin" appearance="small" textAlign={centered ? 'center' : undefined}>
      {children}
    </BodyText>
  </ReadMore>
);

export default SeeMore;
